import feature2 from './Feature2'

export default feature2
